module.exports = __webpack_public_path__ + "img/39.7.Chla.7accbd39.png";